import React, { useEffect, useRef, useState } from 'react';
import { motion, useInView, useMotionValue, useSpring } from 'framer-motion';
const nodes = [{
  label: 'Visitante',
  status: 'Nuevo visitante'
}, {
  label: 'Web',
  status: 'Interacción detectada'
}, {
  label: 'WhatsApp',
  status: 'Mensaje recibido · ahora'
}, {
  label: 'IA',
  status: 'Analizando intención...'
}, {
  label: 'Calificación',
  status: 'Interés: alto'
}, {
  label: 'CRM',
  status: 'Lead actualizado ✓'
}, {
  label: 'Agenda',
  status: '2 horarios disponibles'
}, {
  label: 'Seguimiento',
  status: 'Automatización activa'
}];
export function SystemFlow() {
  const containerRef = useRef<HTMLDivElement>(null);
  const isInView = useInView(containerRef, {
    amount: 0.4
  });
  const [activeIndex, setActiveIndex] = useState(0);
  const rawRotateX = useMotionValue(0);
  const rawRotateY = useMotionValue(0);
  const rotateX = useSpring(rawRotateX, {
    stiffness: 150,
    damping: 20
  });
  const rotateY = useSpring(rawRotateY, {
    stiffness: 150,
    damping: 20
  });
  useEffect(() => {
    if (!isInView) return;
    const prefersReduced = typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) return;
    const interval = setInterval(() => {
      setActiveIndex(i => (i + 1) % nodes.length);
    }, 1700);
    return () => clearInterval(interval);
  }, [isInView]);
  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    const rect = containerRef.current?.getBoundingClientRect();
    if (!rect) return;
    const px = (e.clientX - rect.left) / rect.width - 0.5;
    const py = (e.clientY - rect.top) / rect.height - 0.5;
    rawRotateY.set(px * 6);
    rawRotateX.set(py * -6);
  };
  const handleMouseLeave = () => {
    rawRotateX.set(0);
    rawRotateY.set(0);
  };
  return <div ref={containerRef} onMouseMove={handleMouseMove} onMouseLeave={handleMouseLeave} style={{
    perspective: 1200
  }} className="relative w-full max-w-[340px] mx-auto" data-id="element-239" data-mp="10w514ggug1tv">
      <motion.div style={{
      rotateX,
      rotateY
    }} className="relative flex flex-col py-2" data-id="element-240" data-mp="3k394in1e4a1n">
        <div aria-hidden="true" className="absolute left-[7px] top-[10px] bottom-[10px] w-px bg-carbon/12" data-id="element-241" data-mp="3o2ztqmb9qi42">
          <div className="system-flow-pulse absolute left-1/2 -translate-x-1/2 w-1.5 h-1.5 rounded-full bg-verde" data-id="element-242" data-mp="3f2uvb1o1yu21" />
        </div>

        {nodes.map((node, idx) => {
        const isActive = idx === activeIndex;
        return <motion.div key={node.label} initial={{
          opacity: 0,
          x: 12
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          amount: 0.4
        }} transition={{
          duration: 0.35,
          ease: 'easeOut',
          delay: idx * 0.05
        }} className="relative z-10 flex items-center gap-4 pl-0 py-3" data-id="element-243" data-mp="355p4lujcp52c" data-mpi={idx}>
              <span className={`relative flex items-center justify-center w-3.5 h-3.5 rounded-full border flex-shrink-0 transition-colors duration-300 ${isActive ? 'bg-verde border-verde' : 'bg-arena border-carbon/25'}`} data-id="element-244" data-mp="1yrajjlkirnnw" />
              <span className="flex flex-col leading-tight" data-id="element-245" data-mp="27q5rb237p5tb">
                <span className={`font-body text-[13.5px] font-medium transition-colors duration-300 ${isActive ? 'text-carbon' : 'text-carbon/70'}`} data-id="element-246" data-mp="2lqgm2g7n74jr">
                  {node.label}
                </span>
                <span className={`font-body text-[11px] transition-colors duration-300 ${isActive ? 'text-verde' : 'text-carbon/35'}`} data-id="element-247" data-mp="2vj5s2vkfbq7p">
                  {node.status}
                </span>
              </span>
            </motion.div>;
      })}
      </motion.div>
    </div>;
}